import EditPromotionChallengePage from './EditPromotionChallengePage'
import { withEditPromotionChallengePage } from './withEditPromotionChallengePage'

const ConnectedEditPromotionChallengePage = withEditPromotionChallengePage(
  EditPromotionChallengePage
)

export { ConnectedEditPromotionChallengePage as EditPromotionChallengePage }
